module.exports = __webpack_public_path__ + "static/media/boy_dolls_01.a0d2c1d4.png";